<template>
  <login-form />
</template>

<script>
  import LoginForm from '@core/components/auth/login-form';

  export default {
    components: {
      LoginForm
    }
  };
</script>
